import { sortBy } from 'lodash'
import { StationListItem } from '@/models/InitData'

export type StationFieldId = {
  firldId: []
}

export default class Station {
  public stationId: string
  public name: string
  public latitude: number
  public longitude: number
  public address: string
  public fieldId: string[]
  public areaCode: string
  public threshold: {
    comparison: number
    level: number
    id: string
    title: string
    type: string
    target: string
    status: string
  }[]
  public scale?: {
    maxSample: number
    min: number
    max: number
    span: number
  }
  public popupOffset?: {
    x: number
    y: number
  }
  public ap?: number
  public offset?: {
    x: number
    y: number
  }

  constructor({
    stationId,
    name,
    latitude,
    longitude,
    address,
    fieldId,
    areaCode,
    threshold,
    scale,
    popupOffset,
    ap,
    offset,
  }: StationListItem) {
    this.stationId = stationId
    this.name = name
    this.latitude = latitude
    this.longitude = longitude
    this.address = address
    this.fieldId = fieldId
    this.areaCode = areaCode
    this.threshold = threshold
    this.scale = scale
    this.popupOffset = popupOffset
    this.ap = ap
    this.offset = offset
  }

  get waterThreshold() {
    return sortBy(this.threshold.filter(t => t.type === 'water') || [], 'comparison').reverse()
  }
}
